import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader, setCookie } from "../Helpers";
import {
  STR_CONTACT_US,
  STR_LOGOUT,
} from "../Strings";
import { FaRegUser } from "react-icons/fa";
import { MdChevronRight, MdLogout, MdSupportAgent, MdTranslate, MdVerified } from "react-icons/md";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      appContext.getCurrentUserData(),
    ])
    setReady(true);
  }

  function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie('userId', "", -10000000);
    setCookie('userToken', "", -10000000);
    appContext.navTo({
      item: '',
    })
    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    const user = appContext.currentUserData || {};

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "16px",
          paddingBottom: "calc(var(--topBarHeight) + 40px)",
          background: "linear-gradient(180deg, rgba(255,59,48,0.06) 0%, rgba(255,255,255,0) 32%)",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          {/* Profile Header (ecommerce feel) */}
          <div className="row">
            <div className="col-md-12">
              <div
                style={{
                  borderRadius: "18px",
                  overflow: "hidden",
                  background: "var(--surfaceColor)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  boxShadow: "0 12px 28px rgba(0,0,0,0.10)",
                }}
              >
                <div
                  style={{
                    padding: "16px",
                    background: "linear-gradient(135deg, #ff3b30 0%, #ff8a00 100%)",
                    color: "#fff",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      right: "-18px",
                      top: "-18px",
                      width: "110px",
                      height: "110px",
                      borderRadius: "999px",
                      background: "rgba(255,255,255,0.16)",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div
                        style={{
                          width: "56px",
                          height: "56px",
                          borderRadius: "18px",
                          background: "rgba(255,255,255,0.18)",
                          border: "1px solid rgba(255,255,255,0.22)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <FaRegUser size={26} />
                      </div>

                      <div>
                        <div className="font-bold" style={{ fontSize: "18px", lineHeight: "1.2" }}>
                          +{user.phone || ""}
                        </div>

                        <div
                          className="font-semi-bold"
                          style={{
                            fontSize: "13px",
                            opacity: 0.95,
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            marginTop: "4px",
                          }}
                        >
                          <span>{user.agentName || "Account"}</span>
                          {(user.agentVerificationStatus === 'verified')
                            ? <MdVerified size={16} style={{ color: "rgba(255,255,255,0.95)" }} />
                            : null
                          }
                        </div>
                      </div>
                    </div>

                    <div
                      className="font-bold"
                      style={{
                        padding: "6px 10px",
                        borderRadius: "999px",
                        background: "rgba(255,255,255,0.18)",
                        border: "1px solid rgba(255,255,255,0.22)",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      My Account
                    </div>
                  </div>
                </div>

                <div style={{ padding: "14px 16px" }}>
                  <div
                    className="font-semi-bold"
                    style={{
                      fontSize: "13px",
                      color: "rgba(0,0,0,0.60)",
                    }}
                  >
                    Manage your preferences, language, and support in one place.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="row mt-3">
            <div className="col-md-12">
              <div
                style={{
                  borderRadius: "18px",
                  background: "var(--surfaceColor)",
                  border: "1px solid rgba(0,0,0,0.06)",
                  boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
                  overflow: "hidden",
                }}
              >

                <div
                  style={{
                    padding: "14px 16px",
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <div className="font-bold" style={{ fontSize: "15px" }}>
                    Settings & Help
                  </div>

                  <div
                    className="font-semi-bold"
                    style={{
                      fontSize: "12px",
                      color: "rgba(0,0,0,0.55)",
                    }}
                  >
                    Quick actions
                  </div>
                </div>

                {/* Item */}
                <div
                  onClick={() => {
                    appContext.navTo({
                      item: 'view',
                      subItem: 'contact_us',
                    })
                  }}
                  style={{
                    cursor: "pointer",
                    padding: "14px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div
                      style={{
                        width: "42px",
                        height: "42px",
                        borderRadius: "14px",
                        background: "rgba(255,59,48,0.10)",
                        color: "#ff3b30",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <MdSupportAgent size={22} />
                    </div>

                    <div>
                      <div className="font-semi-bold" style={{ fontSize: "14px" }}>
                        {STR_CONTACT_US[appContext.language]}
                      </div>
                      <div
                        className="font-semi-bold"
                        style={{ fontSize: "12px", color: "rgba(0,0,0,0.55)" }}
                      >
                        Chat with support for orders & delivery
                      </div>
                    </div>
                  </div>

                  <MdChevronRight size={22} style={{ color: "rgba(0,0,0,0.45)" }} />
                </div>

                {/* Language */}
                <div
                  onClick={() => {
                    if (appContext.language === 'en') {
                      appContext.setLanguage("sw");
                    } else {
                      appContext.setLanguage("en");
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    padding: "14px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div
                      style={{
                        width: "42px",
                        height: "42px",
                        borderRadius: "14px",
                        background: "rgba(0,0,0,0.05)",
                        color: "rgba(0,0,0,0.65)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <MdTranslate size={22} />
                    </div>

                    <div>
                      <div className="font-semi-bold" style={{ fontSize: "14px" }}>
                        {(appContext.language === 'en') ? "Tumia Kiswahili" : "Use English"}
                      </div>
                      <div
                        className="font-semi-bold"
                        style={{ fontSize: "12px", color: "rgba(0,0,0,0.55)" }}
                      >
                        Switch language for the storefront
                      </div>
                    </div>
                  </div>

                  <div
                    className="font-bold"
                    style={{
                      padding: "6px 10px",
                      borderRadius: "999px",
                      background: "rgba(0,0,0,0.05)",
                      border: "1px solid rgba(0,0,0,0.06)",
                      fontSize: "12px",
                      color: "rgba(0,0,0,0.70)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {appContext.language === "en" ? "EN" : "SW"}
                  </div>
                </div>

                {/* Logout */}
                <div
                  onClick={() => {
                    appContext.activateDialog({
                      message: STR_LOGOUT[appContext.language] + "?",
                      onConfirm: logOut,
                    })
                  }}
                  style={{
                    cursor: "pointer",
                    padding: "14px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div
                      style={{
                        width: "42px",
                        height: "42px",
                        borderRadius: "14px",
                        background: "rgba(255,59,48,0.10)",
                        color: "#ff3b30",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <MdLogout size={20} />
                    </div>

                    <div>
                      <div className="font-semi-bold" style={{ fontSize: "14px" }}>
                        {STR_LOGOUT[appContext.language]}
                      </div>
                      <div
                        className="font-semi-bold"
                        style={{ fontSize: "12px", color: "rgba(0,0,0,0.55)" }}
                      >
                        Sign out of your account
                      </div>
                    </div>
                  </div>

                  <MdChevronRight size={22} style={{ color: "rgba(0,0,0,0.45)" }} />
                </div>

              </div>
            </div>
          </div>

          {/* Small footer hint */}
          <div
            className="text-center font-semi-bold"
            style={{
              marginTop: "16px",
              fontSize: "12px",
              color: "rgba(0,0,0,0.50)",
            }}
          >
            Secure marketplace • Fast delivery • Trusted sellers
          </div>

        </div>
      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }

}
